import { useEffect } from "react";

const useHeaders = (result: { pageTitle: string }) => {
    useEffect(() => {
        if (result && result.pageTitle) {
            document.title = result.pageTitle;
        }

        //         const scriptBanner = document.createElement("script");

        //         scriptBanner.innerHTML = `!function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyersdk.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: "c32e2fe7-7e3d-4e45-86e7-375693ac21e9"}});
        // AF('banners', 'showBanner')`;
        //         scriptBanner.async = true;

        //         document?.head?.appendChild(scriptBanner);
    }, [result]);
};

export default useHeaders;
